import { NotificationComponentCss, NotificationComponentHtml } from './NotificationComponent.tpl.js';

/**
 * Компонент уведомлений (аналог старого showTips).
 * Слушает CustomEvent 'show-tips' на document.body.
 *
 * Пример отправки:
 *  - Напрямую:
 *      document.body.dispatchEvent(new CustomEvent('show-tips', {
 *          bubbles: true,
 *          detail: { msg: 'Сохранено', type: 'success' }
 *      }));
 *
 *  - Через мост совместимости:
 *      ImViewBridge.execEvent(null, 'show-tips', { msg: 'Ошибка!', type: 'error' });
 */
class NotificationComponent extends HTMLElement {
    constructor() {
        super();
        /** Обработчик для CustomEvent 'show-tips' */
        this._onShowTips = (e) => {
            const ce = e;
            const legacy = e.options; // совместимость с ImViewBridge до правки        
            const payload = ce.detail ?? legacy;
            const msg = payload?.msg;
            const type = payload?.type || 'message';
            if (msg)
                this.showTips(msg, type);
        };
        this.attachShadow({ mode: 'open' });
        // Шаблон как в ProgressBarComponent (style + html)
        const tpl = document.createElement('template');
        tpl.innerHTML = `<style>${NotificationComponentCss}</style>${NotificationComponentHtml}`;
        this.shadowRoot.appendChild(tpl.content.cloneNode(true));
        this._container = this.shadowRoot.querySelector('.notification');
        this._list = this.shadowRoot.querySelector('.notification__list');
    }
    connectedCallback() {
        document.body.addEventListener('show-tips', this._onShowTips);
    }
    disconnectedCallback() {
        document.body.removeEventListener('show-tips', this._onShowTips);
    }
    /**
     * Показать уведомление (аналог старого showTips).
     * @param msg Текст сообщения
     * @param type CSS-модификатор ('error' | 'info' | 'success' | '')
     */
    showTips(msg, type) {
        this._container.hidden = false;
        const el = document.createElement('div');
        el.className = `notification__item ${type}`;
        el.innerHTML = `<span>${msg}</span>`;
        this._list.appendChild(el);
        // Плавный старт
        window.setTimeout(() => el.classList.add('active'), 300);
        // Автоудаление
        window.setTimeout(() => this.removeTip(el), 6000);
    }
    /**
     * Удалить уведомление с анимацией.
     * @param el Элемент уведомления
     */
    removeTip(el) {
        el.classList.remove('active');
        const _onEnd = () => {
            el.removeEventListener('transitionend', _onEnd);
            el.remove();
            if (this._list.children.length === 0) {
                this._container.hidden = true;
            }
        };
        el.addEventListener('transitionend', _onEnd);
    }
}

export { NotificationComponent };
